import { render, staticRenderFns } from "./EditEntrance.vue?vue&type=template&id=72dd3e18&scoped=true&"
import script from "./EditEntrance.vue?vue&type=script&lang=js&"
export * from "./EditEntrance.vue?vue&type=script&lang=js&"
import style0 from "./EditEntrance.vue?vue&type=style&index=0&id=72dd3e18&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72dd3e18",
  null
  
)

export default component.exports